/**
 * The actions a member can be refused for want of a project permission. Each
 * names an i18n phrase under `common.permissions.actions`.
 */
export type DeniedAction =
  | "manageIssues"
  | "addFiles"
  | "deleteFiles"
  | "manageContacts"
  | "viewIssues"
  | "useDrawingViewer"
  | "useModelViewer"
  | "viewContacts";

export interface PermissionDeniedCopy {
  projectAction: string;
  anyProjectAction: string;
  ask: string;
  actions: Record<DeniedAction, string>;
}

/**
 * The two lines of a refusal: what was refused (in this project, or — when no
 * single project is in play — in any of the member's projects), and the ask.
 * It names nobody: who manages access is an organisation's business, and a
 * name in a toast goes stale the moment the roles change.
 */
export function permissionDeniedMessage(
  copy: PermissionDeniedCopy,
  action: DeniedAction,
  scope: "project" | "anyProject"
): { title: string; description: string } {
  const template = scope === "project" ? copy.projectAction : copy.anyProjectAction;
  return {
    title: template.replace("{action}", copy.actions[action]),
    description: copy.ask,
  };
}
